import { useState } from 'react';
import { useAuth } from '../lib/auth';

export function Login() {
  const { signIn, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch {
      // error surfaced via auth context
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="w-full max-w-sm card p-6">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-8 h-8 rounded-md bg-bg-elev border border-edge flex items-center justify-center text-accent font-bold">
            m
          </div>
          <div>
            <div className="font-semibold leading-tight">Meeri</div>
            <div className="text-[11px] text-ink-mute">agentic concierge for your trading floor</div>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-3">
          <label className="block">
            <span className="text-xs text-ink-mute">username or email</span>
            <input
              className="input w-full mt-1"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label className="block">
            <span className="text-xs text-ink-mute">password</span>
            <input
              className="input w-full mt-1"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </label>
          {error && <div className="text-xs text-bad">{error}</div>}
          <button
            type="submit"
            className="btn-primary w-full"
            disabled={busy || !email || !password}
          >
            {busy ? 'signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
}
